import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./AdminLogin.css";
import logo from "../src/assets/img/logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("isAdmin");
  useEffect(() => {
    if (isAdmin === "true") {
      navigate("/dashboard");
    }
  }, [isAdmin, navigate]);

  const handleLogin = async () => {
    if (!mobileNumber || !password) {
      Swal.fire("Error", "Please enter both mobile number and password", "error");
      return;
    }
  
    try {
      setLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_API_URL}admin/admin-login`, {
        mobileNumber,
        userType:"admin",
        password,
      });
  
      if (res.data.status === 1) {
        localStorage.setItem("userid", res.data.user.userId);
        localStorage.setItem("userToken", res.data.token);
        localStorage.setItem("isAdmin", res.data.user.isAdmin);
  
        Swal.fire("Success", "Admin login successful!", "success").then(() => {
          navigate("/dashboard");
        });
      } else {
        Swal.fire("Error", res.data.message || "Login failed", "error");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        Swal.fire("Error", error.response.data.message, "error");
      } else {
        Swal.fire("Error", "An error occurred during login", "error");
      }
    } finally {
      setLoading(false);
    }
  };
  
  
  return (
    <section className="login_area py-5">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-xl-6 offset-xl-3">
            <div className="hfive_card p-6 p-sm-9 rounded-3">
              <a className="navbar-brand d-block mb-4 text-decoration-none text-center">
                <img
                  src={logo}
                  alt="logo"
                  style={{ width: "182px", height: "116px" }}
                  className="img-fluid logo-color"
                />
              </a>

              <div className="login-content">
                <h2 className="h4 fw-bold">Welcome Back</h2>
                <p>Sign in to your account to continue</p>

                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="d-flex flex-column gap-4">
                    <div>
                      <label className="h6 text-opacity-75 mb-3">Mobile Number</label>
                      <input
                        type="text"
                        className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25 py-2 rounded-3"
                        placeholder="Enter Mobile Number"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                      />
                    </div>

                    <div className="position-relative">
                      <label className="h6 text-opacity-75 mb-3">Password</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25 py-2 rounded-3"
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <span
                        className="position-absolute eyess end-0 translate-middle-y pe-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>

                    <div className="d-flex justify-content-between">
                      <div className="d-flex gap-2 align-items-center">
                        <input id="checkbox" type="checkbox" defaultChecked />
                        <label htmlFor="checkbox" className=" text-opacity-75 fs-14">
                          Remember Me
                        </label>
                      </div>
                      <Link to="/forget-password" className="text-decoration-none">
                        <p>Forget Password</p>
                      </Link>
                    </div>

                    <button
                      type="button"
                      className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                      onClick={handleLogin}
                      disabled={loading}
                    >
                      {loading ? "Logging in..." : "Login"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
